'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  if (target === null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var newTarget = target;

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  for (var index = 0; index < args.length; index++) {
    var source = args[index];
    if (source !== null) {
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          newTarget[key] = source[key];
        }
      }
    }
  }
  return newTarget;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-skylight/lib/utils/assign.js
// module id = 1377
// module chunks = 0